import api from './axios';

export const authAPI = {
  login:  (credentials) => api.post('/admin/login', credentials),
  logout: ()            => api.post('/admin/logout'),
  me:     ()            => api.get('/admin/me'),

  /**
   * PUT /api/admin/change-password
   * @param {{ current_password: string, new_password: string, new_password_confirmation: string }} payload
   */
  changePassword: (payload) => api.put('/admin/change-password', payload),
};
